// Google Drive API service for fetching project data
// Uses Netlify function to avoid CORS issues
import logger from '../utils/logger';

/**
 * Fetch all project data from Google Drive via Netlify function
 * @returns {Promise<Object>} Projects dictionary in the same format as buildProjectsDict
 */
export const fetchProjectsFromGoogleDrive = async () => {
  try {
    logger.log('Fetching projects from Google Drive via Netlify function...');

    // Call our Netlify function instead of direct API calls
    const response = await fetch('/.netlify/functions/fetch-projects-ultra');

    if (!response.ok) {
      const errorData = await response.json();
      logger.error('Netlify function error:', response.status, errorData);
      return null;
    }

    const result = await response.json();

    if (result.success && result.projects) {
      logger.log(
        'Successfully fetched projects from Google Drive:',
        Object.keys(result.projects).length,
        'projects'
      );
      return result.projects;
    } else {
      logger.error('Invalid response from Netlify function:', result);
      return null;
    }
  } catch (error) {
    logger.error('Error fetching projects from Google Drive:', error);
    return null;
  }
};

/**
 * Fetch resume URL from Google Drive via Netlify function
 * @returns {Promise<string|null>} Resume URL or null if failed
 */
export const fetchResumeFromGoogleDrive = async () => {
  try {
    logger.log('Fetching resume from Google Drive via Netlify function...');

    // Call our Netlify function instead of direct API calls
    const response = await fetch('/.netlify/functions/fetch-resume');

    if (!response.ok) {
      const errorData = await response.json();
      logger.error('Netlify function error:', response.status, errorData);
      return null;
    }

    const result = await response.json();

    if (result.success && result.resumeUrl) {
      logger.log(
        'Successfully fetched resume URL from Google Drive:',
        result.fileName
      );
      return result.resumeUrl;
    } else {
      logger.error('Invalid response from Netlify function:', result);
      return null;
    }
  } catch (error) {
    logger.error('Error fetching resume from Google Drive:', error);
    return null;
  }
};
